import { polyfill } from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import i18n from '@/lang'
import 'jquery'
import VueClipboard from 'vue-clipboard2'
import store from './store'
import SlideVerify from 'vue-monoplasty-slide-verify'
//global redirect functions
import redirect from '@/util/redirect'
import config from './config'
import DOMPurify from 'dompurify'
import '@/assets/css/global/reset.scss'
import '@/assets/css/global/element.scss'
import '@/assets/css/global/public.scss'
//global filters
import '@/util/filter'
import '@/util/resizeObserver'
import '@/mixins/global'
import Storage from 'vue-ls'
import InputForm from '@/components/form/Input'
import SelectForm from '@/components/form/Select'
import DepositDiscount from '@/components/DepositDiscount'
import DepositCashbackTag from '@/components/depositCashback/Tag'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import '@/assets/css/global/uno.css'
import '@/assets/icons/index'
import { setupSensorsdata } from '@/util/sensorsdata'
import * as Sentry from "@sentry/vue";
import { loadDownloadI18n } from '@/resource/i18n'
import { getTranslatedI18Array } from '@/util/utils'

Sentry.init({
  Vue,
  dsn: "https://beb4a3b07a7a6a7bd0101dca97b84d52@o4507564737232896.ingest.us.sentry.io/4507564738936832",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
try {
  const options = {
    namespace: 'vuejs__', // key键前缀
    name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
    storage: 'local', // 存储名称: session, local, memory
  }
  Vue.use(Storage, options)
  Vue.use(SlideVerify)
  VueClipboard.config.autoSetContainer = true
  Vue.use(VueClipboard)
  Vue.use(ElementUI)
  Vue.config.productionTip = false
  Vue.component(CollapseTransition.name, CollapseTransition)
  Vue.component('InputForm', InputForm)
  Vue.component('SelectForm', SelectForm)
  Vue.component('DepositDiscount', DepositDiscount)
  Vue.component('DepositCashbackTag', DepositCashbackTag)
  Vue.component(VueQrcode.name, VueQrcode);
  Vue.prototype.$redirect = redirect
  Vue.prototype.$config = config
  Vue.prototype.$t.getArray = getTranslatedI18Array
  Vue.prototype.$DOMPurify = DOMPurify
  setupSensorsdata(Vue)

  loadDownloadI18n(i18n.locale).then(() => {
    new Vue({
      el: '#app',
      i18n,
      store,
      router,
      components: { App },
      template: '<App/>',
    })
})
} catch (e) {
  console.log(e)
  throw new Error(e)
}
